import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from '../../components/SearchBox/SearchBox';

import { showAlert } from '../../store/ducks/alert';
import { getPartners, getPartner, createPartner, updatePartner, removePartner } from '../../services/partners';

import { CircularProgress } from '@material-ui/core';
import { Button } from '@getpingback/realeza';
import { PencilSingleIcon, PlusIcon, TrashCanIcon } from '@stash-ui/regular-icons';
import NewPartnerModal from './components/NewPartnerModal';

const Partners = ({ location, match }) => {
  const dispatch = useDispatch();

  const [isNewPartnerModalOpen, setIsNewPartnerModalOpen] = useState(false);
  const [isUpdatingPartner, setIsUpdatingPartner] = useState(false);
  const [partnerFormData, setPartnerFormData] = useState({});

  const [partners, setPartners] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });
  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayPartners(currentPage);
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ['id', 'name', 'partnerType', 'createdAt', 'deletedAt'];
  const SearchBoxHeaders = ['id', 'name'];

  const displayPartners = async currentPage => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };
      const { data: partnersData } = await getPartners(currentPage || page, params);

      setPartners(partnersData.rows);
      setTotalItems(partnersData.count);
      setTotalPages(partnersData.pages);
      setPage(partnersData.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const handleSubmitPartnerFormData = async data => {
    try {
      if (isUpdatingPartner) {
        await updatePartner(data.id, data);
      } else {
        await createPartner(data);
      }

      dispatch(showAlert('success', 'Success! 🔥'));
      window.location.reload();
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something went wrong. 😔'));
    }
  };

  const customActions = [
    {
      icon: <PencilSingleIcon />,
      action: item => {
        handleOpenUpdate(item);
      },
    },
    {
      icon: <TrashCanIcon />,
      action: item => {
        handleRemovePartner(item.id);
      },
    },
  ];

  const handleRemovePartner = async id => {
    try {
      await removePartner(id);
      dispatch(showAlert('success', 'Success! 🔥'));
      window.location.reload();
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something went wrong. 😔'));
    }
  };

  const handleOpenUpdate = async item => {
    const { data } = await getPartner(item.id);
    setIsUpdatingPartner(true);

    setPartnerFormData(data.rows[0]);
    setIsNewPartnerModalOpen(true);
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="users-container">
        <h1>Partners ({totalItems})</h1>

        <div className="users-right">
          <Button appearence="solid" leftElement={<PlusIcon />} onClick={() => setIsNewPartnerModalOpen(true)}>
            Add partner
          </Button>

          <SearchBox
            date-testid="search-box"
            selectItems={SearchBoxHeaders}
            onSubmitSearch={handleSubmitSearch}
            isSearching={isSearching}
            setIsOrdering={setIsOrdering}
          />
        </div>
      </div>

      <DataTable
        head={headers}
        body={partners}
        action={false}
        customActions={customActions}
        bodyColumn={headers}
        linkPath="partners"
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />

      <NewPartnerModal
        isOpen={isNewPartnerModalOpen}
        onClose={() => setIsNewPartnerModalOpen(false)}
        dataForm={partnerFormData}
        isUpdating={isUpdatingPartner}
        onSubmit={handleSubmitPartnerFormData}
      />
    </>
  );
};

export default Partners;
